/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FilterDtoFromJSON, FilterDtoToJSON, } from './FilterDto';
/**
 * Check if a given object implements the UpdateCustomFolderDto interface.
 */
export function instanceOfUpdateCustomFolderDto(value) {
    if (!('folderName' in value) || value['folderName'] === undefined)
        return false;
    if (!('filters' in value) || value['filters'] === undefined)
        return false;
    return true;
}
export function UpdateCustomFolderDtoFromJSON(json) {
    return UpdateCustomFolderDtoFromJSONTyped(json, false);
}
export function UpdateCustomFolderDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'folderName': json['folderName'],
        'filters': FilterDtoFromJSON(json['filters']),
    };
}
export function UpdateCustomFolderDtoToJSON(json) {
    return UpdateCustomFolderDtoToJSONTyped(json, false);
}
export function UpdateCustomFolderDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'folderName': value['folderName'],
        'filters': FilterDtoToJSON(value['filters']),
    };
}
